import { useMemo } from "react";
import { useIntl } from "react-intl";

import TextWithIcon from "@components/text/TextWithIcon";
import { FocusAreaEnum } from "@typing/Generated";

type Props = {
  focusArea: FocusAreaEnum;
};

const FocusArea = ({ focusArea }: Props) => {
  const intl = useIntl();

  const icon = useMemo(() => {
    if (focusArea === FocusAreaEnum.FUNCTIONAL) {
      return "walking";
    }
    if (focusArea === FocusAreaEnum.LEGAL) {
      return "balanceScaleRight";
    }
    if (focusArea === FocusAreaEnum.MEDICAL) {
      return "stethoscope";
    }
    if (focusArea === FocusAreaEnum.SOCIAL) {
      return "handshake";
    }
    if (focusArea === FocusAreaEnum.UNDER_EIGHTEEN) {
      return "child";
    }
    if (focusArea === FocusAreaEnum.WELLBEING) {
      return "spa";
    }
    return "usdCircle";
  }, [focusArea]);

  return <TextWithIcon icon={icon} iconFirst text={intl.formatMessage({ id: `models.focusArea.${focusArea}` })} />;
};

export default FocusArea;
